import { appConfig } from '../env/client';
import axios, { AxiosInstance } from 'axios';

export const request: AxiosInstance = axios.create({
  baseURL: appConfig().BASE_API_URL,
  timeout: 1000 * 60 * 3,
  validateStatus(status) {
    return status === 200;
  }
});
